var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.267 19.145l8.255 8.256c1.414 1.414-.707 3.535-2.121 2.121l-8.256-8.255A10.952 10.952 0 0 1 12.5 23.5c-6.075 0-11-4.925-11-11s4.925-11 11-11 11 4.925 11 11c0 2.497-.832 4.8-2.233 6.645zM12.5 20.5a8 8 0 1 0 0-16 8 8 0 0 0 0 16z"}));
}

Search.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Search;

Search.default = Search;
